export default __webpack_public_path__ + "static/media/sa-site-video-2-264.4dc35a06.mp4";